// Геометрия кадра внутри <video> с object-fit: contain.
// Видео занимает весь контейнер, но сам кадр — только его часть (по бокам или сверху/снизу чёрные поля).
// Точка и рисунок хранятся в долях кадра, поэтому все переводы координат идут через этот прямоугольник.

export const DRAWING_VERSION = 1;
export const DRAWING_COLORS = ["#FF3B30", "#FFD60A", "#30D158", "#3496FF", "#FFFFFF"];
export const DEFAULT_STROKE_WIDTH = 0.005; // доля ширины кадра
export const MAX_DRAWING_BYTES = 200000; // как на сервере (CommentManagementServiceImpl.MAX_DRAWING_BYTES)

/**
 * Прямоугольник кадра относительно containerEl (в px).
 * Если метаданные видео ещё не загружены — возвращает рамку самого <video>.
 */
export function getFrameRect(videoEl, containerEl) {
  if (!videoEl || !containerEl) return null;
  const vr = videoEl.getBoundingClientRect();
  const cr = containerEl.getBoundingClientRect();
  let left = vr.left - cr.left;
  let top = vr.top - cr.top;
  let width = vr.width;
  let height = vr.height;
  const vw = videoEl.videoWidth;
  const vh = videoEl.videoHeight;
  if (vw && vh && width && height) {
    const scale = Math.min(width / vw, height / vh);
    const fw = vw * scale;
    const fh = vh * scale;
    left += (width - fw) / 2;
    top += (height - fh) / 2;
    width = fw;
    height = fh;
  }
  return { left, top, width, height };
}

/** Клиентские координаты → доли кадра (0..1). Выход за кадр обрезается. */
export function clientToFraction(clientX, clientY, videoEl, containerEl) {
  const rect = getFrameRect(videoEl, containerEl);
  if (!rect || !rect.width || !rect.height) return null;
  const cr = containerEl.getBoundingClientRect();
  const x = (clientX - cr.left - rect.left) / rect.width;
  const y = (clientY - cr.top - rect.top) / rect.height;
  return { x: clamp01(x), y: clamp01(y) };
}

/** Клиентские координаты → проценты кадра (0..100), формат markerPoint. */
export function clientToPercent(clientX, clientY, videoEl, containerEl) {
  const f = clientToFraction(clientX, clientY, videoEl, containerEl);
  if (!f) return null;
  return { x: round(f.x * 100, 2), y: round(f.y * 100, 2) };
}

export function clamp01(v) {
  return Math.max(0, Math.min(1, v));
}

export function round(v, digits) {
  const k = Math.pow(10, digits);
  return Math.round(v * k) / k;
}

export function isEmptyDrawing(drawing) {
  return !drawing || !Array.isArray(drawing.strokes) || drawing.strokes.length === 0;
}

/** Размер рисунка в байтах (как его посчитает сервер). */
export function drawingSizeBytes(drawing) {
  if (!drawing) return 0;
  const str = JSON.stringify(drawing);
  if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str).length;
  return unescape(encodeURIComponent(str)).length;
}

/** Путь SVG для штриха в системе координат viewBox (w x h). */
export function strokeToPath(stroke, w, h) {
  const pts = stroke.p || [];
  if (!pts.length) return "";
  if (pts.length === 1) {
    const [x, y] = pts[0];
    // одиночный тап — точка: крошечный отрезок, чтобы сработал round linecap
    return `M ${x * w} ${y * h} L ${x * w + 0.01} ${y * h}`;
  }
  let d = `M ${pts[0][0] * w} ${pts[0][1] * h}`;
  for (let i = 1; i < pts.length; i++) {
    d += ` L ${pts[i][0] * w} ${pts[i][1] * h}`;
  }
  return d;
}
